
import { z } from "zod";

export const FinanciallyResponsiblePartyValues = ["HOMEOWNER", "PARTNER"] as const;
export const FinanciallyResponsiblePartySchema = z.enum(FinanciallyResponsiblePartyValues);
export const FinanciallyResponsibleParty = FinanciallyResponsiblePartySchema.enum;
export type FinanciallyResponsibleParty = (typeof FinanciallyResponsiblePartyValues)[number];
export const FinanciallyResponsiblePartyDisplayNames = { "HOMEOWNER": "Homeowner",
"PARTNER": "Partner", } satisfies Record<FinanciallyResponsibleParty, string>;
